export function parseValue (value) {
    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
}
